import { curry } from 'lib/util'
import { deleteAll } from 'app/_shared/events/notification/alert'

/**
 * Deletes all notifications
 *
 * @param {Function} callback                 callback to execute
 * @param {Gaia.AppModule.Spec} module        module composition
 * @param {Gaia.Component.Spec} component     action component
 * @param {Gaia.AppModule.EventHandler} event triggered event
 * @returns {Promise<void>}
 * @private
 */
const _deleteAll = async (callback, module, component, event) => {
  await deleteAll(module, component, null, callback, event)
}

export default curry(_deleteAll)
